import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { Button } from '@/components/ui';

import { useFormContext } from './contexts';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'disabled'> & {
  label?: string;
  children?: ReactNode;
  variant?: Variant;
  size?: 'sm' | 'md' | 'lg';
  /** MUI compatibility: alias for leftIcon. Replace with `leftIcon` during Phase 4 restyle. */
  startIcon?: ReactNode;
  /** MUI compatibility: alias for rightIcon. */
  endIcon?: ReactNode;
};

export function SubmitButton({
  label = 'Submit',
  children,
  variant = 'primary',
  size,
  startIcon,
  endIcon,
  ...props
}: Props) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => ({ isSubmitting: state.isSubmitting, canSubmit: state.canSubmit })}>
      {({ isSubmitting }) => (
        <Button
          type="submit"
          variant={variant}
          size={size}
          loading={isSubmitting}
          leftIcon={startIcon}
          rightIcon={endIcon}
          {...props}
        >
          {children ?? label}
        </Button>
      )}
    </form.Subscribe>
  );
}
